import { render, staticRenderFns } from "./BeneficiaryDialog.vue?vue&type=template&id=5f7817d6&scoped=true&style=background%3A%20var(--v-muted-base)&"
import script from "./BeneficiaryDialog.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryDialog.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiaryDialog.vue?vue&type=style&index=0&id=5f7817d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7817d6",
  null
  
)

export default component.exports